<template>
  <div>
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-reset': !isIndex }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item class="form-item-primary" prop="phone">
        <!-- 电话号码 -->
        <BaseInput
          v-model.trim="form.phone"
          :autofocus="!isMobile"
          @blur="setAccount(form.phone)"
          @keyup.enter.native="accountNext"
          :validate-event="Boolean(form.phone)"
          :placeholer="$t('login.register.enterYourPhone')"
          :maxLength="11"
        >
          <template #prepend>
            <el-select v-model="form.pretel" style="width: 100px" disabled>
              <el-option
                v-for="item in preTelList"
                :value="item"
                :label="'+' + item"
                :key="'+' + item.toString()"
                >+ {{ item }}</el-option
              >
            </el-select>
          </template>
        </BaseInput>
      </el-form-item>
    </el-form>

    <el-button
      class="button-custom"
      @click="accountNext"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.continue`,
      }"
      >{{ $t('login.loginPage.continue') }}</el-button
    >

    <!-- <BaseLine :text="$t('login.register.or')" /> -->
    <OtherLogin />
  </div>
</template>

<script>
import BaseMixin from '@/mixins/BaseMixin'
import AccountMixins from '@/mixins/AccountMixins.js'
import RegisterStepAccountMixin from '../mixins/RegisterStepAccountMixin.js'
import { checkPhone } from '@/utils/validate-rules'
import store from '@/store'
export default {
  name: '',
  mixins: [BaseMixin, AccountMixins, RegisterStepAccountMixin],
  data() {
    return {
      form: {
        phone: '',
      },
    }
  },

  computed: {
    rules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('login.register.labelRegisteredPhone'),
          },
          {
            validator: async (rule, value, callback) => {
              if (checkPhone(value)) {
                // 检测是否注册
                try {
                  let data = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data.data === true) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = false
                    return callback()
                  } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = true
                    return callback(new Error(this.$t('login.register.exists')))
                  }
                } catch (error) {
                  return callback()
                }
              } else {
                return callback(
                  new Error(this.$t('login.resetPassword.validPhone'))
                )
              }
            },
            trigger: ['blur'],
          },
        ],
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.form-custom {
  margin-top: 40px;
  margin-bottom: 37px;
}
</style>
